(function($) {

  $(document).ready(function() {
    $('.wp-block-gallery').photobox('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".bmp"]');
    $('.wp-block-image').photobox('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".bmp"]');
  	$('.product-image-gallery').photobox('a[href$=".gif"], a[href$=".jpg"], a[href$=".png"], a[href$=".bmp"]');
    
  	// Mobile nav
    var body = $('body');
    var navbarNav = $('.navbar-nav');
    var closeSide = $('.close-side-cover');

    $('.mobile-nav-toggler').click(function(e){
      e.preventDefault();
      if (isOpened()) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    $('.close-mobile-nav').click(function(e){
      e.preventDefault();
      closeMenu();
    });

    var isOpened = function () {
      return navbarNav.hasClass('nav-opened');
    };

    var closeMenu = function () {
      navbarNav.removeClass('nav-opened');
      closeSide.removeClass('close-side-cover-opened');
    };

    var openMenu = function () {
      navbarNav.addClass('nav-opened');
      closeSide.addClass('close-side-cover-opened');
    };

    body.on('click touchstart', '.close-side-cover', function () {
      if (isOpened()) {
        closeMenu();
      } 
    });

    $('.navbar .nav li.menu-item-has-children').each(function(){
      $(this).append('<a href="#" class="dropdown-toggler-icon"></a>');
    });

    $('.navbar-nav').on("click", ".dropdown-toggler-icon", function (e) {
      e.preventDefault();

      if ($(this).parent().hasClass("children-open")) {
        $(this).parent().removeClass("children-open").find("> ul").slideUp(200);
      } else {
        $(this).parent().addClass("children-open").find("> ul").slideDown(200);
      }
    });

    // header cart
    var headerCart = $('.header-cart');
    var isCart = function () {
      return $('body').hasClass('woocommerce-cart');
    };

    var isCheckout = function () {
      return $('body').hasClass('woocommerce-checkout');
    };

    headerCart.hover(function(){
      if (isCart() || isCheckout()) return false;
      headerCart.find('.site-header-cart').addClass('cart-opened');
      }, function(){
      headerCart.find('.site-header-cart').removeClass('cart-opened');
    });

    // Back top button
    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $('#back-to-top').fadeIn();
      } else {
        $('#back-to-top').fadeOut();
      }
    });
    
    // scroll body to 0px on click
    $('#back-to-top').click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 800);
      return false;
    });

    // Product gallery slider
    $('.wpgs img').removeAttr('srcset');

    $('.woocommerce-product-gallery__image img').load(function() {

      var imageObj = $('.woocommerce-product-gallery__image img');

      if (!(imageObj.width() == 1 && imageObj.height() == 1)) {
        $('.attachment-at-shop-thumbnail').trigger('click');
      }
    });

    var numberOfslides = $('.wpgs-nav').children().length;
    if ( numberOfslides >= 4) {
      navForNav = '.wpgs-nav';
    } else{
      navForNav = '';
    }

    $('.wpgs-for').slick({
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      fade:true,
      infinite:false,
      asNavFor: navForNav,
      prevArrow: '<span class="slick-prev"><i class="atuicon-left-open-big"></i></span>',
      nextArrow: '<span class="slick-next"><i class="atuicon-right-open-big"></i></span>',
    });

    $('.wpgs-nav').slick({
      slidesToShow:5,
      slidesToScroll:1,
      asNavFor:'.wpgs-for',
      dots:false,
      infinite:false,
      arrows:true,
      centerMode:false,
      focusOnSelect:true,
      prevArrow: '<span class="slick-prev"><i class="atuicon-left-open-big"></i></span>',
      nextArrow: '<span class="slick-next"><i class="atuicon-right-open-big"></i></span>',
    });

    // All options are stored in array 'var arr []'
    // Each value of the array is stored in the tag '<li>'
    // tag '<li>' is added to the list <ul class = "orderby-list">
    var list = $('.orderby-list');

    var selectedOrderby = $('.orderby option:selected').text();

    // Store options in array
    var arr = $('.orderby option').map(function () {
      return { text: $(this).text(), value: $(this).val() };
    });

    // Append list items to ul.orderby-list
    $.each(arr, function (i) {
      if ( selectedOrderby == arr[i].text ) {
        $('<li>', { text: arr[i].text }).data('val', arr[i].value).appendTo(list).addClass('active');
      }
      else{
        $('<li>', { text: arr[i].text }).data('val', arr[i].value).appendTo(list);
      }
    });

    // change select option if is clicked on list item
    $('.orderby-list li').click(function () {
      $('.orderby').val($(this).data('val')).trigger('change');
    });

    if ( $('.hero-slider').length ) {
      $('.hero-slider .slider').slick({
        slidesToShow:1,
        slidesToScroll:1,
        autoplay:true,
        autoplaySpeed: 5000,
        speed: 500,
        fade:true,
        dots:true,
        infinite:false,
        arrows:true,
        prevArrow: '<span class="slick-prev"><i class="atuicon-left-open-big"></i></span>',
        nextArrow: '<span class="slick-next"><i class="atuicon-right-open-big"></i></span>',
      });
    }

    $('.search-form-toggler').on('click', function(e) {
      if($('.search-form').hasClass('hdn')) {
        e.preventDefault();
        $('.search-form').removeClass('hdn')
        return false;
      }
    });
    
    $('.hide-search-form').on('click', function(e) {
      e.preventDefault();
      $('.search-form').addClass('hdn')
      return false;
    });

  });

})( jQuery );    